'use strict';

/*Plugin By Keinan Pace*/
var Modly = (function() {
    var
        types = [ 'modal', 'notify', 'error' ];
    var clientType;
    var clientMessage;
    var modal;
    var closebtn;
    var overlay;
    var timing;
    var status;

    var say = function(ctype, msg) {
        clientType = ctype.toLowerCase();
        clientMessage = msg;
        buildStructure();
    };

    var buildStructure = function() {
        modal = document.createElement('div');
        closebtn = document.createElement('div');
        overlay = document.createElement('div');
        modal.className = 'flip-modal';
        closebtn.className = 'close-fl';
        overlay.className = 'flip-modal-overlay';
        overlay.appendChild(modal);
        document.body.appendChild(overlay);
        modal.appendChild(closebtn);
        checkType();
    };

    var checkType = function() {
        switch(clientType) {

        case types[0]:

            pushStatusContent();

            break;

        case types[1]:

            pushNotifyContent();

            break;

        case types[2]:

            pushErrorContent();

            break;

        default:

            pushNotifyContent();
    }
    };

    var pushStatusContent = function() {
        modal.innerHTML += '<div>' + clientMessage + '</div>';
        timing = setTimeout(showModal, 300);
    };
    var pushNotifyContent = function() {
        modal.className += ' modal-notify';
        modal.innerHTML = '<div>' + clientMessage + '</div>';
        timing = setTimeout(showModal, 300);

        status = types[1];
    };

    var pushErrorContent = function() {
        modal.innerHTML += '<h1 class=\'m-error-msg\'>Error</h1><p>' + clientMessage + '</p>';
        modal.style.color = 'tomato';
        modal.className += ' modly-error';
        timing = setTimeout(showModal, 300);
    };

    var showModal = function() {
        bindEvents();

        overlay.className += ' m-overlay-show';
        modal.className += ' modly-show';

        if(status == types[1]) {
            overlay.style.backgroundColor = 'transparent';
            timing = setTimeout(killService, 3000);
        }
    };

    var bindEvents = function() {
        overlay.onclick = killService;
        closebtn.onclick = killService;
    };

    var killService = function(e) {
        overlay.classList.remove('m-overlay-show');
        modal.classList.remove('modly-show');

        clearTimeout(timing);

        setTimeout(function() {
            document.body.removeChild(overlay);
        }, 300);
    };

    return {
        say: say
    };
});
